import { render, staticRenderFns } from "./GameKsPage.vue?vue&type=template&id=a42d1f64"
import script from "./GameKsPage.vue?vue&type=script&lang=js"
export * from "./GameKsPage.vue?vue&type=script&lang=js"
import style0 from "./GameKsPage.vue?vue&type=style&index=0&id=a42d1f64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports